import { useSelector } from "react-redux";
import { IAppState } from "../../Common";

export const useLoggedInUser = () => {
  const user = useSelector((state: IAppState) => state.oidc.user);

  return user;
};
